import ChatClient from './chat-client.vue'

const getClient = (() => {
  let client = null
  let wrap = null
  return async () => {
    if (!wrap) {
      wrap = document.createElement('div')
      wrap.style.position = 'relative'
      wrap.style.zIndex = '1059'
      document.getElementById('app').appendChild(wrap)
    }
    if (client) {
      client.visible = false
      await tools.delay(200)
    }
    client = await uif.popup(ChatClient, { loading: false, mask: false, parentNode: wrap })
    client.$once('hook:destroyed', () => { client = null })
    return client
  }
})()

// 开启新对话，立即聊天
export const startChat = async ({ room_title, message_text, options }) => {
  const client = await getClient()
  await client.start({ room_title })
  if (message_text) {
    await client.sendMessage({ message_text, options })
  }
}

